import { Button } from "@etudescarre/ui";
import {
  HouseLine as HouseLineIcon,
  WarningCircle as WarningCircleIcon,
} from "@phosphor-icons/react";
import { useNavigate } from "react-router";

export function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
      <div className="flex min-h-[60vh] flex-col items-center justify-center text-center">
        <WarningCircleIcon className="mb-6 h-24 w-24 text-zinc-400" />
        <h1 className="mb-4 text-4xl font-bold text-zinc-900">
          Page introuvable
        </h1>
        <p className="mb-8 max-w-md text-lg text-zinc-600">
          La page que vous recherchez n'existe pas ou a été déplacée.
        </p>
        <Button
          onClick={() => navigate("/")}
          color="dark/zinc"
          className="gap-2"
        >
          <HouseLineIcon className="h-5 w-5" data-slot="icon" />
          Retour à l'accueil
        </Button>
      </div>
    </div>
  );
}
